import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, finalize, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DocumentTemplate } from '../models/document.model';

@Injectable({
  providedIn: 'root'
})
export class SettingService {
  private _apiUrl = environment.apiUrl + "/v1/Documentos";
  private loadingSubject = new BehaviorSubject<boolean>(true);

  constructor(private http: HttpClient) { }

  getDocumentTemplates(): Observable<DocumentTemplate[]> {
    this.loadingSubject.next(true);

    return this.http.get<DocumentTemplate[]>(this._apiUrl)
    .pipe(finalize(() => this.loadingSubject.next(false)));
  }

  registerDocumentTemplate(document: FormData): Observable<DocumentTemplate> {
    this.loadingSubject.next(true);

    return this.http.post<DocumentTemplate>(this._apiUrl, document)
    .pipe(finalize(() => this.loadingSubject.next(false)));
  }

  deleteDocumentTemplate(documentName: string, documentType: number ): Observable<DocumentTemplate> {
    this.loadingSubject.next(true);

    return this.http.delete<DocumentTemplate>(`${this._apiUrl}/${documentName}/${documentType}`)
    .pipe(finalize(() => this.loadingSubject.next(false)));
  }

  downloadDocument(documentName: string): Observable<Blob> {
    this.loadingSubject.next(true);

    return this.http.get(`${this._apiUrl}/download/${documentName}`, { responseType: 'blob' })
    .pipe(finalize(() => this.loadingSubject.next(false)));
  }
  
  public get loading() {
    return this.loadingSubject.value;
  }
}

